import { securePost } from "config/encryption_decryption/get_post_encryptDecrypt";

export const loginUser = async (username: string, password: string) => {
  return securePost("/api/auth/login", { username, password });
};

export const logOutUser = async () => {
  return securePost("/api/auth/logout", {});
};

export const LoginGoogleapi = async (username: string, password: string) => {
  return securePost("/api/auth/googlelogin", { username, password });
};

export const getPassword = async (user_email: string) => {
  return securePost("/api/user/getPassword", { user_email });
};